import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
  page_template_type: '',
};

const mutations = {
  ['changePageType'](state: any, data: any) {
    state.page_template_type = data;
  },
};

const actions = {};
const getters = {
  ['page_template_type'](state: any) {
    return state.page_template_type;
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
